<select #field
  class="form-control"
  [ngModel]="innerValue"
  (ngModelChange)="writeValue($event)"
  (blur)="onTouched()">
  @if (!required || !innerValue) {
    <option
    [ngValue]="undefined"></option>
  }
  @for (option of orderedOptions; track option) {
    <option
    [ngValue]="option.code">{{ option.displayValue || option.description }}</option>
  }
</select>
